import * as types from '../../constants/actionsType';
import getAllAssetAllocation from '../../../api/assetallocation/assetallocationapi'
import constants from '../../../utils/constants/apiconstant';
export const EpfList=(data)=>{
    return{
        type:types.EPF_LIST,
        payload:data
    }
}